module.exports = __webpack_public_path__ + "img/cargo.60a83a0e.svg";